export enum GA4EventName {
  ADD_OWN_AUDIO = 'AddOwnAudio',
  ADD_SLIDESHOW = 'AddSlideshow',
  START_DRAWING = 'StartDrawing',
  GETTY_IMAGE_LIMIT_REACHED = 'GettyImageLimitReached',
  EXTRACTED_GETTY_STICKER_LIMIT_REACHED = 'ExtractedGettyLimitReached',
  GETTY_VIDEO_LIMIT_REACHED = 'GettyVideoLimitReached',
  GETTY_REMOVE_WATERMARK_CLICKED = 'GettyRemoveWatermarkClicked',
  VIDEO_LIMIT_DIALOG = 'VideoLimitDialog',
  REMOVE_BACKGROUND = 'RemoveBackground',
  REMOVE_BACKGROUND_VIDEO = 'RemoveBackgroundVideo',
  SEARCH_BACKGROUND = 'SearchBackground',
  SEARCH_STORYBLOCKS_ILLUSTRATIONS = 'StoryblocksIllustrationsSearch',
  SEARCH_PIXABAY_ILLUSTRATIONS = 'PixabayIllustrationsSearch',
  ADDED_SLIDESHOW_ANIMATION = 'AddedSlideshowAnimation',
  ADDED_POSTER_ANIMATION = 'AddedPosterAnimation',
  ANIMATION_ITEM_ENTRANCE = 'Animation_Item_Entrance',
  ANIMATION_ITEM_EXIT = 'Animation_Item_Exit',
  ANIMATION_DESIGN_ENTRANCE = 'Animation_Design_Entrance',
  ANIMATION_DESIGN_EXIT = 'Animation_Design_Exit',
  CREATE_POSTER = 'CreatePoster',
  UPLOAD_FONT = 'UploadFont',
  DIGITAL_DISPLAY_PUBLISHED = 'DigitalDisplayPublished',
  EDITOR_ONBOARDING_VISITED = 'EditorOnboarding_Visited',
  EDITOR_ONBOARDING_SKIPPED = 'EditorOnboarding_Skipped',
  DOWNLOAD_CAMPAIGN_PDF = 'EmailPerformance_DownloadCampaign_PDF',
  DOWNLOAD_CAMPAIGN_CSV = 'EmailPerformance_DownloadCampaign_CSV',
  DOWNLOAD_MAILING_LIST_CSV = 'EmailPerformance_DownloadMailingList',
  ACCOUNT_ADDED = 'AccountAdded',
  ACCOUNT_DELETED = 'AccountDeleted',
  ACCOUNT_ADDED_MYSTUFF = 'AccountAdded_MyStuff',
  POST_PUBLISHED = 'PostPublished',
  POST_SCHEDULED = 'PostScheduled',
  PUBLISHING_INTRO_VIDEO = 'PublishingIntroVideo',
  PUBLISHING_ONBOARDING = 'PublishingOnboarding',
  MYSTUFF_SOCIALPOSTS_CREATEDESIGN = 'MyStuff_SocialPosts_CreateDesign',
  MYSTUFF_SOCIALPOSTS_FIXTHIS = 'Socialposts_fixthis',
  SOCIALWIZARD_ACCOUNTADDED = 'SocialWizard_AccountAdded',
  SOCIALWIZARD_NUMPLATFORMS = 'SocialWizard_NumPlatforms',
  SOCIALWIZARD_EDITDESIGN = 'SocialWizard_EditDesign',
  SOCIALWIZARD_RESIZEOPTIONS = 'SocialWizard_ResizeOptions',
  SOCIALWIZARD_AUTORESIZE = 'SocialWizard_AutoResize',
  SOCIALWIZARD_FIXTHIS = 'Socialwizard_fixthis',
  MEDIA_MODAL_OPEN = 'MediaModal_Open',
  UPLOADS_MODAL_OPEN = 'UploadsModal_Open',
  EMAILMAKER_EMBEDVIDEO = 'EmailMaker_EmbedVideo',
  SOCIALWIZARD_AICAPTIONS_CLICKED = 'SocialWizard_AICaptions_Clicked',
  SOCIALWIZARD_AICAPTIONS_ADDED = 'SocialWizard_AICaptions_Added',
  SOCIALWIZARD_AICAPTIONS_FIRSTGEN = 'SocialWizard_AICaptions_FirstGen',
  SOCIALWIZARD_AICAPTIONS_MOREIDEAS = 'SocialWizard_AICaptions_MoreIdeas',
  SOCIALWIZARD_AICAPTIONS_STARTOVER = 'SocialWizard_AICaptions_StartOver',
  SOCIALWIZARD_AICAPTIONS_ONBOARDING_TRYNOW = 'SocialWizard_AICaptions_Onboarding_TryNow',
  SOCIALWIZARD_AICAPTIONS_ONBOARDING_LATER = 'SocialWizard_AICaptions_Onboarding_Later',
  SOCIALWIZARD_AICAPTIONS_REMINDER_VISIBLE_CLICK = 'SocialWizard_AICaptions_Clicked_Popover',
  SOCIALWIZARD_AICAPTIONS_RECENTS = 'SocialWizard_AICaptions_Recents',
  SOCIALWIZARD_AICAPTIONS_UPSELLING = 'SocialWizard_AICaptions_Upselling',
  SOCIALWIZARD_AICAPTIONS_LIMIT_REACHED = 'SocialWizard_AICaptions_DailyLimitHit',
  SOCIALWIZARD_AICAPTIONS_AUTOCAPTIONGEN = 'SocialWizard_AICaptions_AutoCaptionGeneration',
  SOCIALWIZARD_AICAPTIONS_PLATFORMCAPTION = 'Socialwizard_AIcaptions_platformcaption',
  SOCIALWIZARD_UPLOADMEDIA_CLICKED = 'SocialWizard_UploadMedia_Clicked',
  SOCIALWIZARD_UPLOADMEDIA_CREATED = 'SocialWizard_UploadMedia_Created',
  TEMPLATES_MENU_OPEN = 'TemplatesMenu_Open',
  EDITOR_TEMPLATE_ADD = 'EditorTemplate_Add',
  EDITOR_TRY_MENU = 'Editor_TryMenu',
  EDITOR_TRY_STICKER = 'Editor_TrySticker',
  EDITOR_TRY_ANIMATION = 'Editor_TryAnimation',
  EDITOR_TRY_STYLE = 'Editor_TryStyle',
  EDITOR_DOWNLOAD_QR = 'Editor_DownloadQR',
  TEMPLATES_MENU_ADD_AFTER_NEW_POSTER = 'TemplatesMenu_Add_After_New_Poster',
  TEMPLATES_MENU_CLOSE_AFTER_NEW_POSTER = 'TemplatesMenu_Close_After_New_Poster',
  TEXT_MENU_OPEN = 'TextMenu_Open',
  LAYOUT_MENU_OPEN = 'LayoutMenu_Open',
  SLIDESHOW_MENU_OPEN = 'SlideshowMenu_Open',
  BACKGROUND_MENU_OPEN = 'BackgroundMenu_Open',
  QR_CODE_ADDED = 'AddedQRCode',
  TEXT_ITEM_ADDED = 'AddedTextItem',
  TEXT_ITEM_CLICKED = 'ClickedTextItem',
  TEXT_PRESET_ITEM_ADDED = 'AddedTextPresetItem',
  MORE_OPTIONS_OPEN = 'MoreOptions_Open',
  RECORD_MENU_OPEN = 'RecordMenu_Open',
  DESIGNS_MENU_OPEN = 'DesignsMenu_Open',
  UPLOADSMODAL_RECORDED_MEDIA = 'UploadsModal_RecordedMedia',
  UPLOADSMODAL_RECORDED_MEDIA_ADDED = 'UploadsModal_RecordedMedia_Added',
  UPLOADSMODAL_UPLOAD_MEDIA = 'UploadsModal_UploadMedia',
  UPLOADS_MODAL_CREATE_FOLDER = 'UploadsModal_CreateFolder',
  UPLOADS_MODAL_MOVE_TO_FOLDER = 'UploadsModal_MoveToFolder',
  EMAILMAKER_UPLOAD_MEDIA = 'EmailMaker_UploadMedia',
  DESIGNER_PROFILE_CLICK = 'DesignerProfileClick_PosterBuilder',
  AI_MENU_OPEN = 'AIMenu_Open',
  AI_IMAGE_MENU_OPEN = 'AIImageMenu_Open',
  AI_TEXT_MENU_OPEN = 'TextMenu_AITextOpen',
  AI_IMAGE_MENU_GENERATE = 'AIImageMenu_Generate',
  AI_IMAGE_MENU_MODEL = 'AIImageMenu_Model',
  AI_IMAGE_TOTAL_GENERATIONS = 'AIImage_TotalGenerations',
  MEDIA_MODAL_AI_IMAGE_GENERATE = 'MediaModal_AIImage_Generate',
  MEDIA_MODAL_CREATE_AI_STICKERS = 'MediaModal_CreateAIStickers',
  MEDIA_MODAL_CREATE_WITH_AI = 'MediaModal_CreateWithAI',
  MediaModal_AudioFilters = 'MediaModal_AudioFilters',
  MediaModal_ShapeFilter = 'MediaModal_ShapeFilter',
  CREATE_DESIGN_FROM_MEDIA_CLICKED = 'CreatePosterFromUpload_Clicked',
  CREATE_DESIGN_FROM_MEDIA_CREATED = 'CreatePosterFromUpload_Created',
  CONTENTPLANNER_ADD_EMAIL = 'ContentPlanner_AddEmail',
  CONTENTPLANNER_ADD_SOCIAL_POST = 'ContentPlanner_AddSocialPost',
  CONTENTPLANNER_ADD_CUSTOM_EVENT = 'ContentPlanner_AddCustomEvent',
  EMAILMAKER_SUBJECT_LINE_AI_WRITER_CLICKED = 'EmailMaker_SubjectLine_AIWriter_Clicked',
  EMAILMAKER_SUBJECT_LINE_AI_WRITER_GENERATED = 'EmailMaker_SubjectLine_AIWriter_Generated',
  TIMELINE_OPEN = 'Timeline_Open',
  TIMELINE_CLOSE = 'Timeline_Close',
  TIMELINE_EDIT_COMMITTED = 'Timeline_Edit_Committed',
  TIMELINE_SPLIT = 'Timeline_Split',
  TIMELINE_MEDIA_ADDED = 'Timeline_Media_Added',
  TIMELINE_TRANSITION_CLICKED = 'Timeline_Transition_Clicked',
  TIMELINE_MUTE_TOGGLED = 'Timeline_Mute_Toggled',
  TIMELINE_ZOOM = 'Timeline_Zoom',
  CANVAS_ZOOM = 'Canvas_Zoom',
  TIMELINE_MULTISELECT_USED = 'Timeline_MultiSelect_Used',
  TIMELINE_HEIGHT_RESIZED = 'Timeline_Height_Resized',
  TIMELINE_ANIMATE_CLICKED = 'Timeline_Animate_Clicked',
  EDITOR_ITEM_DELETED = 'Editor_Item_Deleted',
  EDITOR_ITEM_ADDED = 'Editor_Item_Added',
  EDITOR_DURATION_SELECTOR_CLICKED = 'Editor_Duration_Selector_Clicked',
  TRIM_AUDIO_MODAL = 'TrimAudio_Modal',
  TRIM_VIDEO_MODAL = 'TrimVideo_Modal',
  SIGN_UP_GOOGLE = 'Google',
  SIGN_UP_FACEBOOK = 'Facebook',
  SIGN_UP_APPLE = 'Apple',
  EMAILMAKER_STYLES_VISITED = 'EmailMaker_Styles_Visited',
  EMAILMAKER_STYLES_APPLIED = 'EmailMaker_Styles_Applied',
  EMAILMAKER_STYLES_SEARCHED = 'EmailMaker_Styles_Searched',
  EMAILMAKER_STYLES_PILLS = 'EmailMaker_Styles_Pills',
  EMAILMAKER_SMARTMAILINGLIST = 'Emailmaker_SmartMailingList',
  EMAILMAKER_SENDCAMPAIGN_SMART_MAILING_LIST = 'Emailmaker_sendcampaign_smartmailinglist',
  EMAILMAKER_SAVE_BLOCKED_BY_BAD_LINK = 'EmailMaker_SaveBlockedByBadLink',
  EMAILMAKER_EMAIL_MARKETING_CAMPAIGN_SENT = 'EmailMaker_EmailMarketingCampaignSent',
  EMAILMAKER_CAMPAIGN_SCHEDULED = 'EmailMaker_CampaignScheduled',
  EMAILMAKER_SEND_TEST_EMAIL = 'EmailMaker_SendTestEmail',
  EMAILMAKER_SEND_BEST_TIME = 'Emailmaker_sendbesttime',
  EMAILMAKER_SCHEDULE_BEST_TIME = 'Emailmaker_schedulebesttime',
  EMAILMAKER_AUTHENTICATE_DOMAIN = 'EmailMaker_authenticatedomain',
  EVENTS_PROMOTE_EMAIL_PUBLISH = 'Events_Promote_Email_Publish',
  EVENTS_PROMOTE_EMAIL_SCHEDULE = 'Events_Promote_Email_Schedule',

  EMAILMAKER_AI_EDIT_CLICKED = 'EmailMaker_AIEdit_Clicked',

  EDITOR_STYLES_VISITED = 'Editor_Styles_Visited',
  EDITOR_STYLES_APPLIED = 'Editor_Styles_Applied',
  EDITOR_STYLES_SEARCHED = 'Editor_Styles_Searched',
  EDITOR_STYLES_PILLS = 'Editor_Styles_Pills',
  EDITOR_STYLES_PALETTE_SHUFFLED = 'Editor_Styles_Palette_Shuffled',
  EDITOR_AIREWRITE_CLICK = 'Editor_AIRewrite_Click',
  EDITOR_AIREWRITE_MOOD = 'Editor_AIRewrite_Mood',
  EDITOR_AIREWRITE_EMOJIS = 'Editor_AIRewrite_Emojis',
  EDITOR_AIREWRITE_APPLIED = 'Editor_AIRewrite_Applied',
  EDITOR_AIREWRITE_SETTINGS = 'Editor_AIRewrite_Settings',
  EDITOR_AIREWRITE_PRESET = 'Editor_AIRewrite_Preset',
  AI_REDESIGN_OPENED = 'AI_REDESIGN_OPENED',
  AI_EDIT_OPEN = 'AIEdit_Open',
  AI_EDIT_GENERATED = 'AIEdit_Generated',
  AI_EDIT_UPLOAD = 'AIEdit_Upload',
  AI_EDIT_COPY_PROMPT = 'AIEdit_copyprompt',
  AI_EDIT_ADD_TO_DESIGN = 'AIEdit_Addtodesign',
  AI_UPSCALE = 'AIUpscale',
  EMAILMAKER_ADD_SECTION = 'EmailMaker_AddSection',
  EMAILMAKER_SECTION_SELECT = 'EmailMaker_SectionSelect',
  EMAILMAKER_SECTION_SAVE = 'EmailMaker_SectionSave',
  EMAILMAKER_SAVED_SECTION_SELECT = 'EmailMaker_SavedSectionSelect',
  EMAILMAKER_ADD_ELEMENT = 'EmailMaker_AddElement',
  EMAILMAKER_SECTIONS_PUBLISHED = 'EmailMaker_SectionsPublished',

  EMAILMAKER_MAILINGLIST = 'EmailMaker_MailingList',
  EMAILMAKER_MAILINGLIST_MYSTUFF_TOPBUTTON = 'EmailMaker_MailingList_MyStuff_TopButton',
  EMAILMAKER_MAILINGLIST_MYSTUFF_PLUSBUTTON = 'EmailMaker_MailingList_MyStuff_PlusButton',
  EMAILMAKER_MAILINGLIST_MYSTUFF_BANNER = 'EmailMaker_MailingList_MyStuff_Banner',
  EMAILMAKER_MAILINGLIST_SIGNUP_FORM = 'EmailMaker_MailingList_SignUpForm',
  EMAILMAKER_AUTO_MAILING_LIST = 'EmailMaker_Auto_MailingList',
  EMAILMAKER_SEND_CAMPAIGN_AUTO_MAILING_LIST = 'EmailMaker_Send_Campaign_Auto_MailingList',
  SIGNUPFORM_CREATE = 'SignUpForm_Create',
  SIGNUPFORM_CREATE_MYSTUFF_TOPBUTTON = 'SignUpForm_Create_MyStuff_TopButton',
  SIGNUPFORM_CREATE_MYSTUFF_PLUSBUTTON = 'SignUpForm_Create_MyStuff_PlusButton',
  SIGNUPFORM_CREATE_MYSTUFF_BANNER = 'SignUpForm_Create_MyStuff_Banner',
  SIGNUPFORM_CREATE_ANONUSER = 'Signupform_anonuser',
  SIGNUPFORM_DEFAULT_FIELDS_TOGGLE = 'SignUpForm_DefaultFieldsToggle',
  SIGNUPFORM_CUSTOM_FIELDS_TOGGLE = 'SignUpForm_CustomFieldsToggle',
  SIGNUPFORM_PUBLISHED = 'EmailMaker_SignUpForm_Published',
  SIGNUPFORM_REPUBLISHED = 'Signupform_Republished',
  BUSINESS_PROFILES_IMPORT = 'BusinessProfiles_Import',
  BUSINESS_PROFILES_CREATE = 'BusinessProfiles_Create',
  BUSINESS_PROFILES_COMPLETE = 'BusinessProfiles_Complete',
  MENU_MAKER_FROM_ADD_TEXT_MENU = 'MenuMakerFromAddTextMenu',
  MENU_MAKER_FROM_CANVAS_EDIT_BUTTON = 'MenuMakerFromCanvasEditButton',
  AI_SUBTITLE_CLICK_MENU = 'AISubtitle_Click_Menu',
  AI_SUBTITLE_CLICK_CONTEXTUAL_MENU = 'AISubtitle_Click_Contextual',
  AI_SUBTITLE_GENERATE = 'AISubtitles_Generate',
  AI_SUBTITLE_TEMPLATE_PRESET_SELECTED = 'AISubtitles_Template_Preset_Selected',

  COPY_STYLES_CLICKED = 'CopyStyles_Clicked',

  EMAILMAKER_MERGE_TAGS_ADDED = 'EmailMaker_MergeTags_Added',
  EMAILMAKER_MERGER_TAGS_IN_CAMPAIGN = 'EmailMaker_MergeTags_Campaign_Sent',
  CREATE_MODAL_BROWSE_DESIGN_TEMPLATES = 'CreateBottomBar_Designs_Browse',
  CREATE_MODAL_BLANK_DESIGN = 'CreateBottomBar_Designs_Blank',
  CREATE_MODAL_BROWSE_EMAIL_TEMPLATES = 'CreateBottomBar_Emails_Browse',
  CREATE_MODAL_BLANK_EMAIL = 'CreateBottomBar_Emails_Blank',
  AI_VOICE_GENERATED = 'AIVoice_Generated',
  AI_VOICE_ADDED = 'AIVoice_Added',
  AI_VOICE_COPY_PROMPT = 'AIVoice_CopyPrompt',
  AI_IMAGE_ADDED = 'AIImage_Added',
  AI_VIDEO_MENU_OPEN = 'AIVideoMenu_Open',
  AI_VOICE_MENU_OPEN = 'AIVoiceMenu_Open',
  AI_VIDEO_GENERATE = 'AIVideoMenu_Generate',
  AI_VIDEO_ADDED = 'AIVideo_Added',
  TURN_INTO_VIDEO = 'TurntoVideo',
  TURN_INTO_VIDEO_CREATE_VIDEO = 'TurntoVideo_CreateVideo',
  TURN_INTO_VIDEO_VIDEO_ADDED = 'TurntoVideo_VideoAdded',
  AI_ANIMATE = 'AIAnimate',
  AI_ANIMATE_CREATE_VIDEO = 'AIAnimate_CreateVideo',
  AI_ANIMATE_VIDEO_ADDED = 'AIAnimate_VideoAdded',
  AI_VOICE_LIMIT_REACHED = 'AIVoice_LimitReached',
  BUSINESS_PROFILES_EMAIL_EDITOR_SOCIAL_LINK = 'BP_EmailEditor_SocialLink',
  BUSINESS_PROFILES_DESIGN_EDITOR_SOCIAL_LINK = 'BP_DesignEditor_SocialLink',
  BUSINESS_PROFILES_DESIGN_EDITOR_QR_CODE = 'BP_DesignEditor_QRCode',
  BUSINESS_PROFILES_DESIGN_EDITOR_SCHEDULE = 'BP_DesignEditor_Schedule',
  BRANDKITS_NEW_GET_FROM_WEBSITE = 'BrandKits_New_GetFromWebsite',
  BRANDKITS_NEW_START_FROM_SCRATCH = 'BrandKits_New_StartFromScratch',
  BUSINESS_PROFILE_POST_ON_GBP = 'BusinessProfile_PostonGBP',
  BUSINESS_PROFILE_EDIT = 'BusinessProfile_Edit',
  AI_IMAGE_PROMPT_COPY = 'AIImage_PromptCopy',
  EVENTS_AICHAT_ENTRY = 'Events_AIChat_Entry',
  EVENTS_ACCESS_FROM_PROMOTE_EMAIL = 'Events_Access_From_Promote_Email',
  EVENTS_AICHAT_CHANGE_STYLE = 'Events_AIChat_ChangeStyle',
  EVENTS_CREATE_BANNER_CLICK = 'Events_Create_Banner_Click',
  EVENTS_CREATE_CLICK = 'Events_Create_Click',
  EVENTS_CREATE_COMPLETE = 'Events_Create_Complete',
  EVENTS_TAB_MYSTUFF_CALENDAR_EDIT = 'Events_Tab_MyStuff_Calendar_Edit',
  EVENTS_TAB_MYSTUFF_CALENDAR_COPY_LINK = 'Events_Tab_MyStuff_Calendar_CopyLink',
  EVENTS_TAB_MYSTUFF_CALENDAR_EMBED = 'Events_Tab_MyStuff_Calendar_Embed',
  EVENTS_TAB_MYSTUFF_CLICK = 'Events_Tab_MyStuff_Click',
  EVENTS_EMBED_WORDPRESS_CLICK = 'Events_Calendar_Wordpress_Embed',
  EVENTS_UPDATE_CLICK = 'Events_Update_Click',
  EVENTS_CREATE_RECURRING = 'Events_Create_Recurring',
  EVENTS_CREATE_VENUE = 'Events_Create_Venue',
  EVENTS_CREATE_SHARE_TEAM = 'Events_Create_Share_Team',
  EVENTS_PAGE_SOCIALS = 'Events_Page_Socials',
  EVENTS_CREATE_VISUALS = 'Events_Create_Visuals',
  EVENTS_APPLY_BRAND_KIT = 'Events_Create_BrandKit',
  EVENT_WIZARD_COMPLETE_FIRST_STEP = 'Events_Create_Next_Step2',
  EVENT_WIZARD_COMPLETE_SECOND_STEP = 'Events_Create_Next_Step3',
  EVENT_WIZARD_APPLY_COLOR = 'Events_Create_Style',
  EVENT_WIZARD_APPLY_BACKGROUND = 'Events_Create_Background',
  EVENT_WIZARD_APPLY_FONT = 'Events_Create_Font',
  EVENT_WIZARD_AI_TYPE_SELECTED = 'Events_Create_Type_AI',
  EVENTS_UPSELLING_DIALOG = 'Events_UpsellingDialog',
  EVENTS_MYSTUFF_SCHEDULE_ADD_TO_WEBPAGE = 'Events_MyStuff_Schedule_AddToWebpage',
  EVENTS_MYSTUFF_ALLOW_REGISTRATIONS = 'Events_MyStuff_Allow_Registrations',
  EVENTS_MYSTUFF_CREATE = 'Events_MyStuff_Create',
  EVENTS_MYSTUFF_DELETE = 'Events_MyStuff_Delete',
  EVENTS_MYSTUFF_DUPLICATE = 'Events_MyStuff_Duplicate',
  EVENTS_MYSTUFF_PREVIEW = 'Events_MyStuff_Preview',
  EVENTS_ONE_CLICK_PROMO_BUTTON = 'Events_One_Click',
  EVENTS_MYSTUFF_VIEW_CHANGE = 'Events_MyStuff_View',
  EVENTS_PROMOTE_EMAIL = 'Events_Promote_Email',
  EVENTS_PROMOTE_SOCIAL = 'Events_Promote_Social',
  EVENTS_MANAGE_ATTENDEES_EDIT = 'Events_Manage_Attendees_Edit',
  EVENTS_MANAGE_INVITE_COPY = 'Events_Manage_Invite_Copy',
  EVENTS_MANAGE_INVITE_EMAIL = 'Events_Manage_Invite_Email',
  EVENTS_MANAGE_PAGE_EDIT = 'Events_Manage_Page_Edit',
  EVENTS_MANAGE_REMINDER = 'Events_Manage_Reminder',
  EVENTS_MANAGE_REMINDER_SAVE = 'Events_Manage_Reminder_Save',
  EVENTS_MANAGE_SIGNUP_EDIT = 'Events_Manage_Signup_Edit',
  EVENTS_SHARE_TEAM_EXTERNAL = 'Events_Share_Team_External',
  EVENTS_ONE_CLICK_PUBLISH = 'Events_One_Click_Publish',
  EVENTS_ONE_CLICK_EMAIL_EDIT_CLICK = 'Events_One_Click_Email_Edit',
  EVENTS_ONE_CLICK_SOCIAL_EDIT_CLICK = 'Events_One_Click_Social_Edit',
  EVENTS_PROMOTE_EMBED = 'Events_Promote_Embed',
  EVENTS_PROMOTE_EVENT_PAGE_SHARE = 'Events_Promote_Event_Page_Share',
  EVENTS_PROMOTE_EMAIL_SKIP = 'Events_Promote_Email_Skip',
  EVENTS_PROMOTE_SOCIAL_SKIP = 'Events_Promote_Social_Skip',
  EVENTS_PROMOTE_EMBED_SKIP = 'Events_Promote_Embed_Skip',
  EVENTS_PROMOTE_PRINT_SKIP = 'Events_Promote_Print_Skip',
  EVENTS_PROMOTE_PAGE_SHARE_SKIP = 'Events_Promote_Event_Page_Share_Skip',
  EVENTS_PROMOTE_COPY_PAGE_LINK = 'Events_Promote_Copy_Page_Link',
  EVENTS_SCHEDULE_APPLY_BRAND_KIT = 'Events_Schedule_BrandKit',
  EVENTS_SCHEDULE_APPLY_COLOR = 'Events_Schedule_Style',
  EVENTS_CALENDAR_APPLY_BACKGROUND = 'Events_Calendar_Background',
  EVENTS_SCHEDULE_APPLY_FONT = 'Events_Schedule_Font',
  EVENTS_SCHEDULE_ADD_LOGO = 'Events_Schedule_Logo',
  EVENTS_SCHEDULE_UPLOAD_COVER = 'Events_Schedule_Cover',
  EVENTS_SCHEDULE_CREATE_EVENT = 'Events_Schedule_Create',
  EVENTS_SCHEDULE_EDIT = 'Events_Schedule_Edit',
  EVENTS_CALENDAR_EDIT = 'Events_Calendar_Edit',
  EVENTS_SCHEDULE_EMBED = 'Events_Schedule_Embed',
  EVENTS_SCHEDULE_EMAIL = 'Events_Schedule_Email',
  EVENTS_SCHEDULE_PHONE_NUMBER = 'Events_Schedule_PhoneNumber',
  EVENTS_SCHEDULE_SOCIALS = 'Events_Schedule_Socials',
  EVENTS_PROMOTE_PRINT_FLYER_DOWNLOAD = 'Events_Promote_Print',
  EVENTS_PROMOTE_CLICK = 'Events_Promote_Click',
  EVENTS_MANAGE_CLICK = 'Events_Manage_Click',
  EVENTS_CREATE_LOGIN_CLICK = 'Events_Create_Login_Click',
  EVENTS_PROMOTE_SOCIAL_PUBLISH = 'Events_Promote_Social_Publish',
  EVENTS_PROMOTE_SOCIAL_SCHEDULE = 'Events_Promote_Social_Schedule',
  EVENTS_COPROMOTER_INVITED = 'Events_Copromoter_invited',
  EVENTS_COPROMOTER_JOINED = 'Events_Copromoter_joined',
  EVENTS_CALENDAR_PROMOTE_EMBED = 'Events_Calendar_Promote_Embed',
  EVENTS_INDIVIDUAL_PROMOTE_EMBED = 'Events_Individual_Promote_Embed',

  COLLABORATION_DESIGN_SHAREINTEAM = 'Collab_Design_Shareinteam',
  COLLABORATION_DESIGN_INVITEBYEMAIL = 'Collab_Design_Inviteemail',
  COLLABORATION_DESIGN_INVITELINK = 'Collab_Design_Invitelink',
  COLLABORATION_DESIGN_INVITEBYEMAIL_RECOMMENDATION = 'Collab_Design_Inviteemail_Recommendation',
  COLLABORATION_DESIGN_ACCESSLEVEL = 'Collab_Design_Accesslevel',
  COLLABORATION_DESIGN_SHAREDWITHME_FILTER = 'Collab_Design_Sharedwithme_Filter',
  COLLABORATION_DESIGN_LANDING_PAGE_NAV_LOGIN_CLICKED = 'Collab_Design_LP_Nav_Login',
  COLLABORATION_FOLDER_SHAREINTEAM = 'Collab_Folder_Shareinteam',
  COLLABORATION_FOLDER_INVITEBYEMAIL_SHAREDIALOG = 'Collab_Folder_Shareinteam_Inviteemail',
  COLLABORATION_FOLDER_INVITELINK_SHAREDIALOG = 'Collab_Folder_Shareinteam_Invitelink',
  COLLABORATION_FOLDER_INVITEBYEMAIL_RECOMMENDATION = 'Collab_Folder_Inviteemail_Recommendation',
  COLLABORATION_FOLDER_ACCESSLEVEL = 'Collab_Folder_Accesslevel',
  COLLABORATION_FOLDER_LANDING_PAGE_NAV_LOGIN_CLICKED = 'Collab_Folder_LP_Nav_Login',
  COLLAB_EMAIL_SHAREINTEAM = 'Collab_Email_Shareinteam',
  COLLAB_MAILINGLIST_SHAREINTEAM = 'Collab_MailingList_Shareinteam',
  COLLAB_SIGNUPFORM_SHAREINTEAM = 'Collab_SignupForm_Shareinteam',
  COLLABORATION_SOCIALPOST_SHAREINTEAM_MYSTUFF = 'Collaboration_SocialPost_Shareinteam_MyStuff',
  COLLABORATION_SOCIALPOST_SHAREINTEAM_WIZARD = 'Collaboration_SocialPost_Shareinteam_Wizard',
  COLLABORATION_SOCIALACCOUNT_SHAREINTEAM_MYSTUFF = 'Collaboration_SocialAccount_Shareinteam_MyStuff',
  HALLOWEEN_2025_BRAND_KIT_USE = 'Halloween25_BrandKitUse',
  BRAND_KITS_PAYG_UPSELL_DIALOG = 'BrandKitsLimitDialog_PAYG',
  BRAND_KITS_PREMIUM_UPSELL_DIALOG = 'BrandKitsLimitDialog_Premium',
  EVENTS_MY_STUFF_CALENDAR_SHARE = 'Events_MyStuff_Calendar_Share',
  PUBLISHING_GENERATE_QR_CODE = 'GenerateQR',
  PUBLISHING_DOWNLOAD_QR_CODE = 'DownloadQR',
  PUBLISHING_COPY_QR_CODE = 'CopyQR',
  PUBLISHING_QUICK_QR_TEMPLATE = 'QuickQRTemplate',
  PUBLISHING_MYSTUFF_WEBLINK_UNPUBLISH = 'Mystuff_Weblink_Unpublish',
  PUBLISHING_MYSTUFF_QRLINK_UNPUBLISH = 'Mystuff_QR_Unpublish',
  PUBLISHING_OPEN_PUBLISH_DIALOG = 'OpenPublishDialog',
  VERSION_HISTORY_OPEN = 'Version_History_Open',
  VERSION_HISTORY_RESTORE = 'Version_History_Restore',
  VERSION_HISTORY_DUPLICATE = 'Version_History_Duplicate',
  EMAILMAKER_VERSION_HISTORY = 'EmailMaker_VersionHistory',
  EMAILMAKER_VERSION_HISTORY_RESTORE = 'EmailMaker_VersionHistory_Restore',
  EMAILMAKER_VERSION_HISTORY_DUPLICATE = 'EmailMaker_VersionHistory_Duplicate',

  NOTIFICATION_NAV_CLICK = 'Notification_Nav_Click',
  NOTIFICATION_CLICK = 'Notification_Click',
  NOTIFICATION_SETTINGS_CLICK = 'Notification_Setting_Click',
  NOTIFICATION_MARK_READ = 'Notification_Mark_Read',
  NOTIFICATION_TOGGLE = 'Notification_Toggle',

  PLAY_PAGE = 'PlayPage',
  ADD_PAGE = 'AddPage',
  SAVE_TO_DRIVE = 'SaveToDrive',
  PRINT_SHOP_LINK = 'PrintShop_Link',
  DOWNLOAD_OPTIONS = 'DownloadOptions',
  NEW_DOWNLOAD_DIALOG_OPEN = 'OpenNewDownloadDialog',
  POST_DOWNLOAD_UPSELLING_CLICK = 'PostDownload_UpsellClick',
  POST_DOWNLOAD_UPSELLING_CLOSE = 'PostDownload_UpsellClose',
  POST_DOWNLOAD_UPSELLING_OPEN = 'PostDownload_UpsellOpen',
  POST_DOWNLOAD_UPGRADE = 'DownloadDialogue_Upgrade',
  POST_DOWNLOAD_OPTIONS = 'PostDownload_Options',
  PUBLISH_NOW_DOWNLOAD_DIALOG = 'PublishNow',
  NAVBAR_SEARCH = 'Nav_Search',
  EVENTS_CALENDAR_LAYOUT_SELECTED = 'Events_Calendar_Layout_Selected',
  EVENTS_CALENDAR_SUBVIEW_CHANGED = 'Events_Calendar_Subview_Changed',
  AICHAT_DOWNLOAD = 'AIChat_Download',
  AICHAT_PUBLISH = 'AIChat_Publish',
  AICHAT_SHARE = 'AIChat_Share',
  AICHAT_OPEN_EDITOR = 'AIChat_OpenEditor',
  AICHAT_EDIT = 'AIChat_Edit',
  AICHAT_NO_CREDITS = 'AIChat_NoCredits',
  AICHAT_ALL_CHATS = 'AIChat_AllChats',
  AICHAT_START = 'AIChat_Start',
  AICHAT_HOMEPAGE = 'AIChat_Homepage',
  AICHAT_CREDITS_FINISHED = 'AIChat_CreditsFinished',
  AICHAT_SAVE_TO_MY_DESIGNS = 'AIChat_SavetoMyDesigns',
  AICHAT_EDIT_MESSAGE = 'AIChat_EditMessage',
  AICHAT_VOICE_START = 'AIChat_VoiceStart',
  AICHAT_VOICE_END = 'AIChat_VoiceEnd',
  AICHAT_VOICE_LIMIT = 'AIChat_VoiceLimit',
  AICHAT_ATTACHMENTS = 'AIChat_Attachments',
  AICHAT_QUICK_TIPS = 'AIChat_QuickTips',
  AICHAT_QUICK_TIPS_EXPAND = 'AIChat_QuickTipsExpand',
  SEO_LANDING_PAGE_AI_CHAT_HERO = 'seolandingpages_aichathero',
  CROP_APPLIED = 'CropApplied',
  CROP_ELEMENT = 'CropElement',
  MASK_APPLIED = 'MaskApplied',
  REPLACE_ELEMENT = 'ReplaceElement',
  TEXT_EDIT = 'TextEdit',
  ADD_BRAND_FONT = 'AddBrandFont',
  ADD_BRAND_COLOR = 'AddBrandColor',
  DESIGN_TEMPLATE_SUBMITTED = 'DesignTemplateSubmitted',
  AICHAT_TEMPLATES_VIEWMORE = 'AIChat_Templates_Viewmore',
  AICHAT_TEMPLATES_ATTACH = 'AIChat_Templates_Attach',
  AICHAT_TEMPLATES_DONTSHOW = 'AIChat_Templates_Dontshow',
  AICHAT_TURNTOVIDEO_OPENINEDITOR = 'AIChat_Turntovideo_Openineditor',
  AICHAT_TURNTOVIDEO = 'AIChat_Turntovideo',
  AICHAT_TURNTOVIDEO_DOWNLOAD = 'AIChat_Turntovideo_Download',
  AICHAT_TURNTOVIDEO_PUBLISH = 'AIChat_Turntovideo_Publish',
  AICHAT_MY_AI_DESIGNS = 'AIChat_MyAIDesigns',
  AICHAT_MEMORY_OPEN = 'AIChat_MemoryOpen',
  AICHAT_MEMORY_REMOVE = 'AIChat_MemoryRemove',
  AICHAT_MY_AI_DESIGN_CLICKED = 'AIChat_MyAIDesign_Clicked',
  AICHAT_MY_AI_DESIGN_OPEN_IN_CHAT = 'AIChat_MyAIDesign_OpenInChat',
  AICHAT_BRANDKIT_SELECTED = 'AIChat_Brandkit_Selected',
  AICHAT_BRANDKIT_CREATE = 'AIChat_Brandkit_Create',
  AICHAT_BRANDKIT_REMOVED = 'AIChat_Brandkit_Removed',
  AICHAT_ASPECT_RATIO_CHANGED = 'AIChat_AspectRatio_Changed',

  LAYERS_CLICKED = 'Layers_Clicked',
  LAYERS_SELECTED = 'Layers_Selected',
  LAYER_ARRANGED = 'Layer_Arranged',

  MYSTUFF_EMPTYSTATE = 'MyStuff_EmptyState',
  MYSTUFF_EMPTYSTATE_ACCOUNT_ADDED = 'Emptystate_accountadded',
  MYSTUFF_EMPTYSTATE_CREATE_POST = 'Emptystate_createpost',
  MYSTUFF_EMPTYSTATE_PUBLISH_YOUR_DESIGN = 'Emptystate_publishyourdesign',
  MYSTUFF_EMPTYSTATE_START_WITH_TEMPLATE = 'Emptystate_startwithtemplate',
  MYSTUFF_POSTEREDIT_DROPDOWNOPTION_CLICKED = 'MyStuff_PosterEdit_DropdownOption_Clicked',
  EVENTS_TICKETING_COMING_SOON = 'Events_TicketingComingSoon',
  EVENTS_TICKETING_COMING_SOON_NOTIFY = 'Events_TicketingComingSoon_Notify',
  EVENTS_TICKETING_TYPE_SWITCH = 'Events_Ticketing_Type_Switch',
  EVENTS_TICKETING_SETUP_COMPLETE = 'Events_Ticketing_Setup_Complete',
  EVENTS_TICKETING_STRIPE_START = 'Events_Ticketing_Stripe_Start',
  EVENTS_TICKETING_STRIPE_COMPLETE = 'Events_Ticketing_Stripe_Complete',
  EVENTS_TICKETING_STRIPE_SECTION_VIEW = 'Events_Ticketing_Stripe_Section_View',
  EVENTS_MANAGE_TICKETING_VIEW = 'Events_Manage_Ticketing_View',
  EVENTS_TICKETING_CAP_HIT = 'Events_Ticketing_Cap_Hit',
  EVENTS_TICKETING_UPGRADE_CLICK = 'Events_Ticketing_Upgrade_Click',
  EVENTS_TICKETING_CHECKIN_MODE_ENTER = 'Events_Ticketing_Checkin_Mode_Enter',
  EVENTS_TICKETING_CHECKIN_SCAN = 'Events_Ticketing_Checkin_Scan',
  EVENTS_TICKETING_CHECKIN_MANUAL = 'Events_Ticketing_Checkin_Manual',
  EVENTS_TICKETING_ATTENDEE_ADD = 'Events_Ticketing_Attendee_Add',
  EVENTS_TICKETING_ATTENDEE_LIST_DOWNLOAD = 'Events_Ticketing_Attendee_List_Download',
  EVENTS_TICKETING_ATTENDEE_DETAIL_VIEW = 'Events_Ticketing_Attendee_Detail_View',
  EVENTS_TICKETING_TICKET_ACTION = 'Events_Ticketing_Ticket_Action',
  EVENTS_TICKETING_REFUND_INITIATE = 'Events_Ticketing_Refund_Initiate',
  EVENTS_TICKETING_CHECKOUT_START = 'Events_Ticketing_Checkout_Start',
  EVENTS_TICKETING_CHECKOUT_COMPLETE = 'Events_Ticketing_Checkout_Complete',
  EVENTS_TICKETING_CHECKOUT_TIMEOUT = 'Events_Ticketing_Checkout_Timeout',
  EVENTS_TICKETING_PAYMENT_SUCCESS = 'Events_Ticketing_Payment_Success',
  EVENTS_TICKETING_CONFIRMATION_ACTION = 'Events_Ticketing_Confirmation_Action',
  EVENTS_TICKETING_ORDER_PAGE_ACTION = 'Events_Ticketing_Order_Page_Action',
  EVENTS_TICKETING_PAID_ENABLED = 'Events_Ticketing_Paid_Enabled',
  EVENTS_CREATE_TICKETING_POPUP = 'Events_Create_Ticketing_Popup',
  EVENTS_CALENDAR_FOLLOWERS = 'Events_Calendar_Followers',
  EVENTS_CALENDAR_FOLLOWER_FREQUENCY = 'Events_Calendar_Follow_Frequency',

  FAKEDOOR_EVERGREEN_POST_CLICKED = 'Fakedoor_evergreenpostclicked',
  FAKEDOOR_EVERGREEN_POST_PUBLISHED = 'Fakedoor_evergreenpostpublished',
  FAKEDOOR_PROMPT_PILL_CLICKED = 'Fakedoor_promptpillclicked',
  FAKEDOOR_POST_USED = 'Fakedoor_postused',

  QR_TOOL_TYPE_SELECTED = 'QRTool_Type_Selected',
  QR_TOOL_STYLE_APPLIED = 'QRTool_Style_Applied',
  QR_TOOL_LOGO_ADDED = 'QRTool_Logo_Added',
  QR_TOOL_DOWNLOAD = 'QRTool_Download',
  QR_TOOL_COPY = 'QRTool_Copy',
  QR_TOOL_DESIGN_SELECTED = 'QRTool_Design_Selected',
  QR_TOOL_GALLERY_CLICK = 'QRTool_Gallery_Click',
}

/**
 * GA4 custom events for the cancel-subscription dialog, named `canceldialog_<panel>_<cta>` so each step of the
 * cancellation funnel can be told apart even where two panels share a button label (e.g. "Cancel anyway").
 *
 * GA4 caps an event name at 40 characters, so a few labels are shortened to fit: `continuecancel`,
 * `keepsub`, and `claimoffer` (one event for both tenure-gated variants of the retention offer button).
 */
export enum CancelDialogGA4Event {
  FEATURES_KEEP_SUBSCRIPTION = 'canceldialog_features_keepsubscription',
  FEATURES_CONTINUE_CANCEL = 'canceldialog_features_continuecancel',
  /** "Pause instead" in the credits-loss banner. Qualified by banner because the literal label does not fit in 40 chars. */
  FEATURES_PAUSE_CREDITS = 'canceldialog_features_pause_credits',
  /** "Pause subscription instead" in the price-increase banner. */
  FEATURES_PAUSE_PRICERISE = 'canceldialog_features_pause_pricerise',
  FEATURES_CLOSE = 'canceldialog_features_close',

  SURVEY_PAUSE_SUBSCRIPTION = 'canceldialog_survey_pausesubscription',
  SURVEY_CONFIRM_CANCELLATION = 'canceldialog_survey_confirmcancellation',
  SURVEY_DISCOUNT_SHOWN = 'canceldialog_survey_discountshown',
  SURVEY_TO_CHEAPER_PLANS = 'canceldialog_survey_tocheaperplans',
  SURVEY_TO_PAUSE = 'canceldialog_survey_topause',
  SURVEY_TO_SUPPORT_FORM = 'canceldialog_survey_tosupportform',
  SURVEY_BACK = 'canceldialog_survey_back',
  SURVEY_CLOSE = 'canceldialog_survey_close',

  DISCOUNT_CLAIM_OFFER = 'canceldialog_discount_claimoffer',

  PAUSESTEP_PAUSE_SUBSCRIPTION = 'canceldialog_pausestep_pausesubscription',
  PAUSESTEP_CANCEL_ANYWAY = 'canceldialog_pausestep_cancelanyway',
  PAUSESTEP_BACK = 'canceldialog_pausestep_back',
  PAUSESTEP_CLOSE = 'canceldialog_pausestep_close',

  SWITCHPLAN_SWITCH_PLAN = 'canceldialog_switchplan_switchplan',
  SWITCHPLAN_STAY_ON_THIS_PLAN = 'canceldialog_switchplan_stayonthisplan',
  SWITCHPLAN_CANCEL_ANYWAY = 'canceldialog_switchplan_cancelanyway',
  SWITCHPLAN_BACK = 'canceldialog_switchplan_back',
  SWITCHPLAN_CLOSE = 'canceldialog_switchplan_close',

  SUPPORTFORM_SUBMIT_FEEDBACK = 'canceldialog_supportform_submitfeedback',
  SUPPORTFORM_CANCEL_ANYWAY = 'canceldialog_supportform_cancelanyway',
  SUPPORTFORM_BACK = 'canceldialog_supportform_back',
  SUPPORTFORM_CLOSE = 'canceldialog_supportform_close',

  SUPPORTSENT_KEEP_SUB = 'canceldialog_supportsent_keepsub',
  SUPPORTSENT_CANCEL_ANYWAY = 'canceldialog_supportsent_cancelanyway',
  SUPPORTSENT_CLOSE = 'canceldialog_supportsent_close',

  /** "Submit feedback" with text in the box, so feedback is actually sent. */
  POSTCANCEL_SUBMIT_FEEDBACK = 'canceldialog_postcancel_submitfeedback',
  /** "Submit feedback" with an empty box. Kept separate so the event above only ever counts real feedback. */
  POSTCANCEL_SUBMIT_EMPTY = 'canceldialog_postcancel_submitempty',
  POSTCANCEL_SKIP_FEEDBACK = 'canceldialog_postcancel_skipfeedback',
  POSTCANCEL_CLOSE = 'canceldialog_postcancel_close',
}

export enum CancelDialogGA4EventParam {
  PLAN = 'plan',
}

export enum MyStuffEmptyStateHash {
  DESIGNS = 'Designs',
  SOCIALMEDIA = 'Socialmedia',
  EVENTS = 'Events',
  EMAIL = 'Email',
}

export enum AddPageGA4EventParams {
  TIMELINE = 'timeline_button',
  PAGE_BOTTOM_BUTTON = 'page_bottom',
  PAGE_RIGHT_OPTIONS = 'page_right',
  ALL_PAGES_MOBILE = 'all_pages_mobile',
  CONTEXTUAL_MENU_MOBILE = 'contextual_menu_mobile',
}

export enum GA4EventParam {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
}

export enum GA4EventTextTypeParam {
  PLAIN = 'plain',
  FANCY = 'fancy',
  TRANSCRIPT = 'transcript',
  SLIDESHOW = 'slideshow',
  TEXT_PRESET = 'textpreset',
}

export enum GA4EventTextButtonTypeParam {
  PLAIN = 'plain',
  FANCY = 'fancy',
  SLIDESHOW = 'slideshow',
  TEXT_PRESET = 'textpreset',
  MENU = 'menu',
  MANUAL_SUBTITLE = 'manualsubtitle',
  AI_SUBTITLE = 'aisubtitles',
  AI_TEXT_ART = 'aitextart',
}

export enum GA4EventParamName {
  SEARCH_TERM = 'searchTerm',
  PROMPT = 'prompt',
  TYPE = 'type',
  SLIDE_NUMBER = 'slideNumber',
  PLATFORM = 'platform',
  NUM_PLATFORMS = 'num_platforms',
  SIGNUP_PARAM_NAME = 'method',
  TERM = 'term',
  SEATS = 'seats',
  HASHED_ID = 'hashedId',
  USER_PREMIUM_LEVEL = 'userPremiumLevel',
  SOURCE = 'source',
  SIGNUP_FORM_FIELD_NAME = 'fieldName',
  SIGNUP_FORM_CUSTOM_FIELD_INDEX = 'customFieldIndex',
  MENU_OPENED_FROM = 'menuOpenedFrom',
  AI_SUBTITLE_TEMPLATE_ID = 'aiSubtitleTemplateId',
  TEMPLATE_ID = 'templateId',
  POSTER_TYPE = 'posterType',
  MERGE_TAGS = 'mergeTags',
  CAMPAIGN_ID = 'campaignId',
  VALUE = 'value',
  ANIMATION_TYPE = 'AnimationType',
  ITEM_TYPE = 'ItemType',
  VIEW = 'View',
  AUTO_MAILING_LIST_TYPE = 'AutoMailingListType',
  TO = 'to',
  FEE_STRATEGY = 'fee_strategy',
  FORM_SCOPE = 'form_scope',
  TAX = 'tax',
  EVENT_TYPE = 'event_type',
  MODE = 'mode',
  PLAN = 'plan',
  CAP_TYPE = 'cap_type',
  RESULT = 'result',
  ACTION = 'action',
  PAYMENT_METHOD = 'payment_method',
  QUANTITY = 'quantity',
  EMAIL_OPT_IN = 'email_opt_in',
  CHECKED_IN = 'checked_in',
  REASON = 'reason',
  SCOPE = 'scope',
  DIRECTION = 'direction',
  TIMELINE_STATE = 'timeline_state',
  ADD_TYPE = 'add_type',
}

export enum TurnIntoVideoGA4EventParamName {
  HAS_PROMPT = 'hasPrompt',
}

export enum TurnIntoVideoGA4PromptParam {
  WITH_PROMPT = 'WithPrompt',
  WITHOUT_PROMPT = 'WithoutPrompt',
}

export enum GA4EventSources {
  CONTEXTUAL_MENU = 'ContextualMenu',
  MOBILE_BOTTOM_BAR = 'BottomBar',
  LEFT_TOOLBAR = 'LeftToolbar',
  NAV_FILE_DROPDOWN = 'Dropdown',
  AUTO_SAVE_HOVER = 'Hover',
  CANVAS = 'Canvas',
  TIMELINE = 'Timeline',
  KEYBOARD = 'Keyboard',
  POPUP_MENU = 'PopupMenu',
}

export enum TimelineOpenSource {
  EDIT_TIMELINE_PILL = 'edit_timeline_pill',
  AUDIO_ICON = 'audio_icon',
  AUDIO_ADDED = 'audio_added',
  CREATE_FROM_MEDIA_AUTO = 'create_from_media_auto',
  WEBPAGE_AUTO = 'webpage_auto',
  /** A phone reopened the timeline because the user last left it open. */
  MOBILE_RESTORED = 'mobile_restored',
}

export enum TimelineState {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum TimelineEditAction {
  DRAG_MOVE = 'drag_move',
  ROW_REORDER = 'row_reorder',
  NEW_ROW = 'new_row',
  CROSS_TRACK_CONVERT = 'cross_track_convert',
  GROUP_DRAG = 'group_drag',
  BACKGROUND_REORDER = 'background_reorder',
  TRIM_START = 'trim_start',
  TRIM_END = 'trim_end',
  GROUP_TRIM = 'group_trim',
  TRANSITION_RESIZE = 'transition_resize',
}

export enum TimelineMediaAddOption {
  UPLOADS = 'uploads',
  STOCK = 'stock',
  TEXT = 'text',
  AI = 'ai',
  AI_VOICE = 'ai_voice',
  RECORD = 'record',
  BLANK = 'blank',
  DESIGN = 'design',
  TEMPLATE = 'template',
}

export enum TimelineMultiSelectType {
  SHIFT_CLICK = 'shift_click',
  CMD_CLICK = 'cmd_click',
}

export enum TimelineMuteTarget {
  AUDIO_ROW = 'audio_row',
  VIDEO_BACKGROUND = 'video_background',
}

export enum TimelineTransitionClickAction {
  CHIP_CLICK = 'chip_click',
  REGION_SELECT = 'region_select',
}

export enum TimelineSplitSource {
  TOOLBAR = 'toolbar',
  KEYBOARD = 'keyboard',
  POPUP_MENU = 'popup_menu',
  MOBILE_BAR = 'mobile_bar',
}

export enum TimelineZoomSource {
  SLIDER = 'slider',
  BUTTONS = 'buttons',
  WHEEL_OR_PINCH = 'wheel/pinch',
  PINCH = 'pinch',
}

export enum CanvasZoomSource {
  BUTTONS = 'buttons',
  KEYBOARD = 'keyboard',
  WHEEL_OR_PINCH = 'wheel/pinch',
  PINCH = 'pinch',
  FIT_TO_SCREEN = 'fit_to_screen',
}

export enum ZoomDirection {
  IN = 'in',
  OUT = 'out',
}

export enum EditorMediaEvent {
  Audio_Fade_Add = 'Editor_Audio_Fade_Add',
  Audio_Fade_Removed = 'Editor_Audio_Fade_Removed',
  EDITOR_RECORDEDMEDIA_ADDED = 'Editor_RecordedMedia_Added',
  EDITOR_RECORDEDMEDIA_RETAKE = 'Editor_RecordedMedia_Retake',
}

export enum StyleType {
  BRAND_KIT = 'Brand Kit',
  ALL_STYLES = 'All Styles',
  RECENTS = 'Recents',
}

/**
 * GA4 `source` values reported with the design-tile events (MyStuff_PosterEdit_*). The tiles on the My Stuff pages
 * themselves are rendered by PHP and tracked from /public/assets/javascript/views/my-stuff.js, which owns the rest of
 * this vocabulary — keep the shared values byte-identical.
 */
export enum MyStuffPosterGA4Source {
  EVENT_PROMOTION = 'Event promotion',
}

/**
 * GA4 `source` values reported with Events_Create_Click. The other entry points carry their own value: the nav's
 * Create and Events dropdowns report 'Nav' from the Navbar facades, and the My Stuff announcement banner reports
 * 'MyStuff-Announcement' from /public/assets/javascript/views/my-stuff.js.
 */
export enum EventsCreateGA4Source {
  MY_STUFF_MY_EVENTS = 'MyStuff-MyEvents',
  MY_STUFF_EVENTS_CALENDAR = 'MyStuff-EventsCalendar',
  MY_STUFF_SHARED_WITH_ME = 'MyStuff-SharedwMe',
  MY_STUFF_MOBILE_BAR = 'MyStuff-MobileBar',
  HOMEPAGE = 'Homepage',
}

export enum GA4TemplateAddTypes {
  DEFAULT = 'Default',
  RECOMMENDED = 'Recommended',
}

export enum GA4EmailCampaignType {
  EMAIL = 'Email',
  DESIGN = 'Design',
}

export const NEW_SUBSCRIPTION_START_SOURCE_COOKIE = 'new-subscription-start-source';

export enum NewSubscriptionStartSource {
  EDITOR_UPGRADE_BUTTON = 'editor_cta',
  MY_STUFF_UPGRADE_BUTTON = 'mystuff_cta',
  PAYG_DOWNLOAD_DIALOG = 'paygdownload_dialog',
  VERSION_HISTORY_UPGRADE_BUTTON = 'versionhistory_link',
  PAYG_MULTIPAGE_LIMIT_DIALOG = 'paygmultipagelimit_downloaddialogue',
  MY_STUFF_OFFER_AD = 'mystuff_offerad',
  HALLOWEEN_DOWNLOAD_UPSELLING = 'halloween_downloadupselling',
  AI_CHAT_AGENT_UPSELL = 'aichat_agentupsell',
}

export enum EventUpsellGA4Source {
  MORE_EVENTS = 'moreeventpages',
  MORE_EVENTS_PREMIUM = 'morepagespremium',
  REMOVE_WATERMARK = 'removewatermark',
  DESCRIPTION_REWRITE_AI = 'rewriteaidescription',
  REGISTRATION_OPTIONS = 'guestinfo',
  RECURRING = 'recurringevents',
  NUM_GUESTS_LIMIT = 'unlimitedregistrations',
  VIEW_ANALYTICS = 'eventsmetrics',
  REMINDERS = 'reminders',
  TICKETING = 'eventticketing',
  TICKETING_PAYG = 'ticketing_payg',
  CUSTOM_FORMS = 'eventcustomforms',
  SHARE_TEAM = 'teams',
  EVENT_ONE_CLICK_PROMOTION = 'oneclickpromo',
}

export enum CollaborationGA4Source {
  MY_STUFF = 'My Stuff',
  DIALOG = 'Dialog',
  EMAIL_EDITOR = 'Email Editor',
  SIGNUPFORM_EDITOR = 'SignupForm Editor',
}

export enum SignupFormPublishType {
  LINK_TO_FORM = 'LinkToForm',
  POPUP = 'Popup',
  EMBEDDED_FORM = 'EmbeddedForm',
}

export enum CollaborationGA4Toggle {
  SHARED = 'shared',
  UNSHARED = 'unshared',
}

export enum NotificationsSettingsToggleSource {
  SM_POSTS = 'sm_posts',
  EMAILS = 'email_campaign',
  EVENTS = 'events',
  TEAM = 'team',
  DESIGN = 'design',
  ALL = 'all',
}

export enum AiChatStartSource {
  AI_HOMEPAGE = 'AI_Homepage',
  MY_STUFF = 'My_Stuff',
  TEMPLATE_PREVIEW_DIALOG = 'Template_Preview_Dialog',
  NAVBAR_PROMPT_BOX = 'Navbar_Prompt_Box',
  AI_MARKETING_PAGE = 'AI_Marketing_Page',
  SEO_LANDING_PAGE = 'SEO_Landing_Page',
}

export enum AiChatOpenEditorType {
  EDIT_AS_IMAGE = 'editasimage',
  EDITABLE_LAYERS = 'editablelayers',
}

export enum AIChatHomepageSource {
  MY_STUFF = 'My_Stuff',
}

export enum AiChatTemplateAttachOrigin {
  PROMPTBOX_PILL = 'promptboxpill',
  PROMPTBOX_ATTACHMENTS = 'promptboxattachments',
  RECOMMENDED_TEMPLATES = 'recommendedtemplates',
  VIEW_MORE = 'viewmore',
  NEGATIVE_FEEDBACK = 'negativefeedback',
}

export enum AiChatTurnToVideoSource {
  AD = 'ad',
  DESIGN = 'design',
}

export enum AiChatTurnToVideoType {
  WITH_AUDIO = 'with audio',
  SILENT = 'silent',
}

export enum AiChatVideoActionSource {
  MY_DESIGNS = 'mydesigns',
  CHAT = 'chat',
}

export enum AiChatTurnToVideoPublishType {
  SOCIAL_MEDIA = 'social media',
  EVENT = 'event',
  EMAIL = 'email',
}

export enum AiChatPublishType {
  SOCIAL_MEDIA = 'SocialMedia',
  EVENT = 'Event',
  EMAIL = 'Email',
}

export enum AiMenuOpenSource {
  MEDIA_DRAWER = 'media drawer',
  UPLOADS = 'uploads',
  LEFT_SIDE_MENU = 'leftsidemenu',
  BOTTOM_DRAWER = 'bottomdrawer',
}

export enum LayersGA4Source {
  CANVAS = 'canvas',
  RIGHTCLICK = 'rightclick',
  SHORTCUT = 'shortcut',
  BOTTOM_BAR = 'bottom_bar',
  ITEM_BOTTOM_BAR = 'item_bottom_bar',
}

export const EMAILMAKER_ADD_SECTION_BLANK_SECTIONS = 'Empty';

// Mirrored as a string literal in legacy-js/core.js (PMW.gtm.logEventForDebug_) — legacy JS cannot import TS.
const GA_DEBUG_LOGGING_STORAGE_KEY = 'pmwGaDebug';
const GA_DEBUG_LOGGING_ENABLED_VALUE = '1';

export const isGaDebugLoggingEnabled = (): boolean => {
  try {
    return window.localStorage.getItem(GA_DEBUG_LOGGING_STORAGE_KEY) === GA_DEBUG_LOGGING_ENABLED_VALUE;
  } catch {
    return false;
  }
};

export const setGaDebugLoggingEnabled = (isEnabled: boolean): void => {
  try {
    if (isEnabled) {
      window.localStorage.setItem(GA_DEBUG_LOGGING_STORAGE_KEY, GA_DEBUG_LOGGING_ENABLED_VALUE);
    } else {
      window.localStorage.removeItem(GA_DEBUG_LOGGING_STORAGE_KEY);
    }
  } catch {
    // storage unavailable (private mode / blocked) — the logger is a dev convenience, fail silently
  }
};

// GA4 custom events that should additionally be mirrored to Hotjar as custom events (via the dataLayer -> GTM Hotjar tag).
const HOTJAR_MIRRORED_EVENTS = new Set<string>([
  GA4EventName.LAYERS_CLICKED,
  GA4EventName.AI_VIDEO_MENU_OPEN,
  GA4EventName.TURN_INTO_VIDEO_CREATE_VIDEO,
  GA4EventName.AI_ANIMATE_CREATE_VIDEO,
  GA4EventName.AI_EDIT_GENERATED,
]);

const trackCustomEvent = (event: string, params?: Record<string, string>): void => {
  window.PMW.gtm.trackGA4CustomEvent(event, params);
  if (HOTJAR_MIRRORED_EVENTS.has(event)) {
    window.PMW.gtm.trackHotjarEvent(event);
  }
};

export const trackPublishingGA4Events = (event: string, params?: Record<string, string>): void => {
  trackCustomEvent(event, params);
};

export const trackPosterBuilderGA4Events = (event: string, params?: Record<string, string>): void => {
  trackCustomEvent(event, params);
};

export const trackGA4CustomEvent = (event: string, params?: Record<string, string>): void => {
  trackCustomEvent(event, params);
};

export const trackMyStuffEmptyStateEvent = (hash: MyStuffEmptyStateHash): void => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.MYSTUFF_EMPTYSTATE, {[GA4EventParamName.SOURCE]: hash});
};
